"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../core/utils");

var PriceZone_1 = require("../model/PriceZone");

var PriceZoneConverter_1 = require("./PriceZoneConverter");
/**
 * Default implementation of PriceZoneConverter.
 *
 * @author JMe
 * @author JMr
 * @author RBe
 */


var PriceZoneConverterImpl =
/*#__PURE__*/
function (_PriceZoneConverter_) {
  _inherits(PriceZoneConverterImpl, _PriceZoneConverter_);

  function PriceZoneConverterImpl() {
    _classCallCheck(this, PriceZoneConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneConverterImpl).apply(this, arguments));
  }

  _createClass(PriceZoneConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceZone_1.PriceZone(PriceZone_1.PriceZone.schema.id.valueOf(conversions.documentToClassId(source)), PriceZone_1.PriceZone.schema.numericId.valueOfField(source), PriceZone_1.PriceZone.schema.name.valueOfField(source), PriceZone_1.PriceZone.schema.description.valueOfField(source), PriceZone_1.PriceZone.schema.groupOfSitesId.valueOf(conversions.toClassReferenceId(source.groupOfSitesId)), PriceZone_1.PriceZone.schema.competitorSitesIds.valueOf(conversions.asObjectList(source, 'competitorSitesIds', function (value) {
        if (utils_1.Utils.isValueMissing(value)) {
          throw new DataDictionaryError_1.DataDictionaryError("competitor site id cannot be empty!");
        }

        return conversions.toClassReferenceId(value);
      })), PriceZone_1.PriceZone.schema.archived.valueOfField(source), PriceZone_1.PriceZone.schema.isNational.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        name: source.name,
        description: source.description,
        groupOfSitesId: conversions.toDocumentReferenceId(source.groupOfSitesId),
        competitorSitesIds: conversions.asObjectArray(source, 'competitorSitesIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        archived: source.archived,
        isNational: source.isNational
      });

      if (source.numericId !== utils_1.Utils.VOID_NUMERIC_ID) {
        // FIXME JGr LOG-1622
        // This function is used to convert data from user to json which is consequently persisted.
        // Numeric ID cannot be changed during update and we don't want to load current value from DB.
        // So if we are processing update then we replace value from user by VOID. Here we are able
        // to recognize this situation and ignore the value.
        Object.assign(document, {
          numericId: source.numericId
        });
      }

      return document;
    }
  }]);

  return PriceZoneConverterImpl;
}(PriceZoneConverter_1.PriceZoneConverter);

exports.PriceZoneConverterImpl = PriceZoneConverterImpl;